import styled, { css, keyframes } from 'styled-components';
import cardBg from '../../assets/images/card_bg.png';
import decBg from '../../assets/images/dec.png';
import decBottom from '../../assets/images/wallet_bottom_dec.png';
import walletText from '../../assets/images/wallet_text.png';

const StyledWallet = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 600px;
	height: 600px;
	background: linear-gradient(
			180deg,
			rgba(0, 0, 0, 0) 93.27%,
			rgba(0, 0, 0, 0.5) 100%
		),
		#0f0f0f;
	border-radius: 60px;
	background-image: url(${decBg});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
`;

const StyledCardsContainer = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
`;

const StyledTopMask = styled.div<{ $disabled?: boolean; $topPad?: number }>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	clip-path: ${({ $disabled, $topPad }) => {
		if ($disabled) return 'none';
		const pad = $topPad ?? 0;
		return `inset(${pad ? `-${pad}px` : '0'} 0 400px 0)`;
	}};
`;

const extractLift = ($endTilt: number) => keyframes`
  0% { transform: translateX(-50%) translateY(0) rotate(0deg) scale(1); box-shadow: 0 10px 30px rgba(0,0,0,0.3); }
  60% { transform: translateX(-50%) translateY(-220px) rotate(${
		$endTilt >= 0 ? 2 : -2
	}deg) scale(1.02); box-shadow: 0 28px 56px rgba(0,0,0,0.4); }
  100% { transform: translateX(-50%) translateY(0) rotate(${$endTilt}deg) scale(1); box-shadow: 0 10px 30px rgba(0,0,0,0.3); }
`;

const StyledCardWrapper1 = styled.div<{
	$isExtracted?: boolean;
	$forceZ?: boolean;
}>`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: ${({ $isExtracted }) => ($isExtracted ? '161px' : '80px')};
	width: 520px;
	height: 300px;
	z-index: ${({ $isExtracted, $forceZ }) => ($forceZ || $isExtracted ? 20 : 1)};
	transition:
		top 260ms ease,
		z-index 0ms linear 0ms;
	cursor: pointer;
`;

const StyledCard = styled.div<{
	$tilt?: number;
	$isExtracted?: boolean;
	$animPhase?: 'extract' | 'collapse';
}>`
	position: absolute;
	left: 50%;
	transform: ${({ $tilt }) => `translateX(-50%) rotate(${$tilt ?? 0}deg)`};
	top: 0;
	width: 500px;
	height: 300px;
	background: url(${cardBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
	${({ $animPhase, $tilt }) =>
		$animPhase &&
		css`
			animation: ${extractLift($tilt ?? 0)} 360ms cubic-bezier(0.2, 0.7, 0.2, 1)
				both;
			animation-direction: ${$animPhase === 'collapse' ? 'reverse' : 'normal'};
		`}
`;

const StyledCardWrapper2 = styled.div<{
	$isExtracted?: boolean;
	$maskOff?: boolean;
	$forceZ?: boolean;
}>`
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: ${({ $isExtracted }) => ($isExtracted ? 'auto' : '39px')};
	top: ${({ $isExtracted }) => ($isExtracted ? '161px' : 'auto')};
	width: 520px;
	height: 300px;
	clip-path: ${({ $maskOff, $isExtracted }) =>
		$maskOff || $isExtracted ? 'none' : 'url(#walletCutout)'};
	z-index: ${({ $forceZ, $isExtracted, $maskOff }) =>
		($forceZ || $isExtracted) && $maskOff ? 20 : 1};
	transition:
		top 260ms ease,
		bottom 260ms ease,
		z-index 0ms linear 0ms,
		clip-path 0ms;
	cursor: pointer;
`;

const StyledCard2 = styled.div<{
	$isExtracted?: boolean;
	$tilt?: number;
	$animPhase?: 'extract' | 'collapse';
}>`
	position: absolute;
	left: 50%;
	transform: ${({ $tilt }) => `translateX(-50%) rotate(${$tilt ?? 0}deg)`};
	top: ${({ $isExtracted }) => ($isExtracted ? '0' : '-100px')};
	width: 500px;
	height: 300px;
	background: url(${cardBg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
	will-change: transform;
	${({ $animPhase, $tilt }) =>
		$animPhase &&
		css`
			animation: ${extractLift($tilt ?? 0)} 360ms cubic-bezier(0.2, 0.7, 0.2, 1)
				both;
			animation-direction: ${$animPhase === 'collapse' ? 'reverse' : 'normal'};
		`}
`;

const StyledSvgDefs = styled.svg`
	position: absolute;
	width: 0;
	height: 0;
	pointer-events: none;
`;

const StyledBottomDec = styled.div`
	position: absolute;
	bottom: 39px;
	left: 50%;
	transform: translateX(-50%);
	width: 521px;
	height: 301px;
	background-image: url(${decBottom});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	z-index: 10;
`;

const StyledCard2Shadow = styled.div`
	position: absolute;
	width: 500px;
	height: 142px;
	left: 50%;
	transform: translateX(-50%);
	top: 160px;
	background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, #000000 100%);
	opacity: 0.75;
	z-index: 10;
	pointer-events: none;
`;

const StyledCard1Shadow = styled.div<{
	$opacity?: number;
	$isTopExtracted?: boolean;
}>`
	position: absolute;
	width: 500px;
	height: 220px;
	left: 50%;
	transform: translateX(-50%);
	top: 0px;
	z-index: 10;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0) 0%,
		rgba(16, 16, 16, 0.85) 80%,
		#101010 100%
	);
	pointer-events: none;
	opacity: ${({ $opacity }) => $opacity ?? 1};
	transition:
		opacity 220ms ease,
		clip-path 100ms ease 0.15s;
	clip-path: inset(
		0 0 ${({ $isTopExtracted }) => ($isTopExtracted ? '60px' : '20px')} 0
	);
`;

const StyledWalletText = styled.div`
	position: absolute;
	top: 35px;
	left: 50%;
	transform: translateX(-50%);
	width: 188px;
	height: 59px;
	background-image: url(${walletText});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
`;

export {
	StyledBottomDec,
	StyledCard,
	StyledCard1Shadow,
	StyledCard2,
	StyledCard2Shadow,
	StyledCardsContainer,
	StyledCardWrapper1,
	StyledCardWrapper2,
	StyledSvgDefs,
	StyledTopMask,
	StyledWallet,
	StyledWalletText,
};
